import { render, staticRenderFns } from "./Home-Footer.vue?vue&type=template&id=3916451a&scoped=true&"
var script = {}
import style0 from "./Home-Footer.vue?vue&type=style&index=0&id=3916451a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3916451a",
  null
  
)

export default component.exports